import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, useEffect } from "react";
import { useAtom } from "jotai";
import { userAtom } from "./store/user";
import { useStorageMigrationIdb } from "./hooks/useStorageMigrationIdb";

const queryClient = new QueryClient();

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const App = function () {
  const [, setUser] = useAtom(userAtom);

  useStorageMigrationIdb();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    // is ?logout=true
    if (searchParams.get("logout") === "true") {
      setUser(null);
    }
  }, []);

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>
  );
};
